<template>
  <div class="wrap">
    <v-data-table
        :headers="headers"
        :items="faqs"
        sort-by="calories"
        class="elevation-1"
    >
        <template v-slot:top>
        <v-toolbar flat color="white">
            <v-toolbar-title>Manage Frequently Asked Questions</v-toolbar-title>
            <v-divider
                class="mx-4"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" outlined dark class="mb-2" v-on="on">New Item</v-btn>
            </template>
            <v-card>
                <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="editedItem.question" label="Question"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="editedItem.answer" label="Answer"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
            edit
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
            delete
        </v-icon>
        </template>
        <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
  </div>
</template>

<script>

import {
    listFAQs as listService,
    createFAQ as createService,
    editFAQ as editService,
    deleteFAQ as deleteService
} from '../../services/faq';

import { extractError } from '../../utils/error';

export default {
  data: () => ({
    dialog: false,
    faqs: [],
    headers: [
    {
        text: 'Question',
        align: 'left',
        sortable: false,
        value: 'question',
    },
    {
        text: 'Answer',
        value: 'answer' },
    {
        text: 'Actions',
        value: 'action',
        sortable: false
    },
    ],
    editedIndex: -1,
    editedItem: {
        question: '',
        answer: '',
        category: 'FAQ'
    },
    defaultItem: {
        question: '',
        answer: '',
        category: 'FAQ'
    },
  }),
  computed: {
    formTitle () {
    return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {
    dialog (val) {
    val || this.close()
    },
  },
  created () {
    this.initialize()
  },
  methods: {
    getId(faq) {
        const { _links: { fAQ: { href: actualLink } } } = faq;
        const group = actualLink.match(/.*(\d+)/);
        return group[1];
    },
    async initialize () {
        const { _embedded: { fAQs: faqs } } = await listService();
        this.faqs = faqs;
    },
    async editItem (item) {
        this.editedIndex = this.faqs.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    },

    async deleteItem (item) {
        const index = this.faqs.indexOf(item);
        if(confirm('Are you sure you want to delete this item?')) {
            try {
                const faqId = this.getId(this.faqs[index]);
                const result = await deleteService(faqId);
                console.log('delete result : ', result);
            }
            catch(err) {
                console.log(err);
                this.$showError(extractError(err));
            }
        }
    },

    close () {
        this.dialog = false
        setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        }, 300)
    },

    async save () {
        try {
            if (this.editedIndex > -1) {
                const { _links: { fAQ: { href: actualLink } } } = this.editedItem;
                const group = actualLink.match(/.*(\d+)/)
                const id = group[1];
                await editService(id, this.editedItem);
                Object.assign(this.faqs[this.editedIndex], this.editedItem)
            } else {
                await createService(this.editedItem);
                this.faqs.push(this.editedItem)
            }
            this.close()
        }
        catch(err) {
            console.log(err);
            const message = extractError(err);
            this.$showError(message);
        }
    },
  },
}
</script>

<style lang="sass" scoped>
  .wrap
    padding: 50px
</style>